var _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 234.5 234.4",
    style: {
      enableBackground: "new 0 0 234.5 234.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Circle_bg_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Circle_bg_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 68.0353,
    y1: -110.6013,
    x2: 166.9252,
    y2: 110.5187,
    gradientTransform: "matrix(1 0 0 1 0 117.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8BD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#EC9500"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Circle_bg",
    className: "st0",
    d: "M117.2,0C52.5,0.1,0,52.6,0.1,117.3s52.6,117.2,117.3,117.1c64.7-0.1,117.1-52.5,117.1-117.2 C234.5,52.5,182,0,117.2,0C117.2,0,117.2,0,117.2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Lion",
    className: "st1",
    d: "M213.7,123.3c0.1-2,0.2-4,0.2-6.1c0-14.8-3.3-29.5-9.7-42.9l-44-25.3l29.7,3.3 c-7.2-8.4-15.7-15.5-25.2-21.1l-58.2-1.1l32.5-9.6c-8.1-2.1-16.4-3.1-24.8-3.1c-16.1,0-32,3.9-46.2,11.4l10.7,18.6L58.9,34.2 c-0.6,0.4-1.1,0.7-1.7,1.1l11.6,21L50,72.2l-1.9,14.7L20.6,114l15-2.4l7.8,3.1l-20.6,15.6l8.7,11.4l26,2.1L71,133.1l-10-8.5 l37.3-2.5l16.1-17.4l-6.2-40.5l26.4,43.5L108,174l-0.6-39.8l-16.8,43.5L61,201.6c15.9,10,34.2,15.3,53,15.4l27.5-61.1l-4.4,58.4 c12.2-2.9,23.8-8.1,34.1-15.3l-1-73l21.1,54.3c7.8-9.6,13.8-20.5,17.6-32.3l-25.7-52.4L213.7,123.3z M77.5,91.7l-14.3,3l-7.6,8.8 l-4.3,2.8l10.1-19.5l-0.2-7.2l29.3-0.9C90.5,78.7,77.5,91.7,77.5,91.7z M79.3,161.3l-11.8-9.2L54,156.5l-18.5-4.9l6.3,17.5l12.9,8.5 l7.2-6.3L79.3,161.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ed4f804a.svg";
export { ForwardRef as ReactComponent };